import { jwtContextFactory } from '@state/checkout-contexts';

import type { ScaJwtPayload } from '../../global.types';

const {
  JwtContextProvider,
  useJwtContext,
  withJwtContextProvider,
  withJwtContextDecorator,
} = jwtContextFactory<ScaJwtPayload>();

export {
  JwtContextProvider,
  useJwtContext,
  withJwtContextProvider,
  withJwtContextDecorator,
};
